import { supportChatPath } from '../../paths';

/**
 * The URL that opens `sessionId` in this console, on the host it is served
 * from. The admin is a hash router, so the route goes after "#": ant builds
 * the same shape for Slack ("<ADMIN_BASE_URL>/#/support/chat/<id>"). Not
 * history.createHref, which has no origin.
 */
export const sessionLink = (
  sessionId: string,
  location: Pick<Location, 'origin' | 'pathname'> = window.location
): string => `${location.origin}${location.pathname}#${supportChatPath(sessionId)}`;
